import initialState from './initialState'
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as getDashboard } from './getDashboard/reducer'
import { reducer as setFilter } from './setFilter'
import { reducer as setFilterDate } from './setFilterDate'
import { reducer as clearDashboardSettings } from './clearDashboardSettings'
import { reducer as setGroupSelector } from './setGroupSelector'
import { reducer as setShowDashCard } from './setShowDashCard'

const reducers = [
    getDashboard,
    setFilter,
    setFilterDate,
    clearDashboardSettings,
    setGroupSelector,
    setShowDashCard,
];

export default function reducer(state = initialState, action = {}) {
  let newState;
    if (action.type === LOGOUT_USER) {
        newState = initialState;
    }
    else {
      newState = state;
    }
  return reducers.reduce((s, r) => r(s, action), newState);
}